import { combineReducers } from 'redux';
import * as R from './reducer';
export default combineReducers(R);